//TODO add all UI rules here then remove from invidivual components then just import this file
const rules = {
    required: value => !!value || 'Required.',
    min: v => v.length >= 8 || 'Min 8 characters',
    counter: value => value.length <= 20 || 'Max 20 characters',
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
    },
    cellphone: value => {
        const pattern = /\d{2}\d{3}\d{7}/
        return pattern.test(value) || 'Invalid Cellphone no.'
    },
    zipCode: value => {
        const pattern = /\d{4}/
        return pattern.test(value) || 'Invalid Zip Code'
    },
    max_days: value => value<=365 || 'Invalid Amount. Maximum of 365' 
    
    //add other custom UI rules here
}
export default rules;